import React from 'react';
import { MetaPixel } from './components/MetaPixel';
import { AnnouncementBar } from './components/AnnouncementBar';
import { HeroSection } from './components/HeroSection';
import { StatsBar } from './components/StatsBar';
import { TransformationSection } from './components/TransformationSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { PainPointsSection } from './components/PainPointsSection';
import { KitContentsSection } from './components/KitContentsSection';
import { InstantAccessSection } from './components/InstantAccessSection';
import { BonusesSection } from './components/BonusesSection';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full bg-tr-cream font-sans text-tr-grey selection:bg-tr-orange/25" data-id="element-0" data-mp="3ij64a9st9l7v">
      <MetaPixel data-id="element-1" data-mp="3mk84otygs3bf" />
      <AnnouncementBar data-id="element-2" data-mp="3mjq45l4rr2xp" />
      <main className="pt-9" data-id="element-3" data-mp="3rc9e8848zfxr">
        <HeroSection data-id="element-4" data-mp="3rbzo8kj7d8s2" />
        <StatsBar data-id="element-5" data-mp="3rdkkqfp2v1sk" />
        <TransformationSection data-id="element-6" data-mp="3recerm310rgq" />
        <BeforeAfterSection data-id="element-7" data-mp="5or2zhbcs60" />
        <PainPointsSection data-id="element-8" data-mp="4wx1t3d72hu" />
        <KitContentsSection data-id="element-9" data-mp="56m9egl55mh" />
        <InstantAccessSection data-id="element-10" data-mp="2zl3c5m4yv85u" />
        <BonusesSection data-id="element-11" data-mp="2zlv32jnmchps" />
        <OfferSection data-id="element-12" data-mp="2zmo5j8fjol24" />
        <GuaranteeSection data-id="element-13" data-mp="2zng14j956ise" />
        <TestimonialsSection data-id="element-14" data-mp="33m5be2yvvk7t" />
        <FAQSection data-id="element-15" data-mp="33ngdzzglelxc" />
        <FinalCTASection data-id="element-16" data-mp="33mykvbp88ntn" />
      </main>
      <Footer data-id="element-17" data-mp="38m1e7yvuh5ls" />
    </div>;
}